{
  "appName": "Opti-Sea",
  "disclaimer": "Not affiliated with or endorsed by RightShip.",
  "actions": {
    "back": "Back",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "continue": "Continue",
    "save": "Save",
    "done": "Done"
  },
  "languages": {
    "en": "English"
  },
  "status": {
    "not_started": "Not started",
    "in_progress": "In progress",
    "closed": "Closed",
    "office_action": "Office action"
  },
  "sync": {
    "allSaved": "All saved to server",
    "lastSync": "Last sync {{time}}",
    "sending": "Sending changes…",
    "waitingForWifi": "Waiting for Wi-Fi",
    "noInternet": "No internet",
    "savedOnPhone": "Your work is saved on the phone",
    "pending_one": "{{count}} change waiting",
    "pending_other": "{{count}} changes waiting",
    "problem": "Some changes need attention",
    "details": "Sync details"
  },
  "feedback": {
    "savedOnPhone": "Saved on phone",
    "savedOnPhoneDetail": "It is sent to the office when sync is available."
  },
  "positions": {
    "MASTER": "Master",
    "CO": "Chief Officer",
    "2O": "Second Officer",
    "3O": "Third Officer",
    "CE": "Chief Engineer",
    "2E": "Second Engineer",
    "3E": "Third Engineer",
    "ETO": "Electro-Technical Officer"
  },
  "workTypes": {
    "inspection": {
      "name": "Physical inspection"
    },
    "request": {
      "name": "Items to be requested"
    },
    "policy": {
      "name": "SMS / IMS procedure"
    },
    "training": {
      "name": "Training or drill needed"
    },
    "paper": {
      "name": "Paperwork & records"
    }
  },
  "timings": {
    "six_months": {
      "short": "6-m",
      "meaning": "Start 6 months before the inspection"
    },
    "three_months": {
      "short": "3-m",
      "meaning": "Start 3 months before the inspection"
    },
    "last": {
      "short": "Last",
      "meaning": "Do during the last voyage before the inspection"
    },
    "final_24h": {
      "short": "C/L",
      "meaning": "Do in the last 24 hours before the inspection"
    }
  },
  "statusMeaning": {
    "not_started": "Nobody has started yet",
    "in_progress": "Work has started",
    "closed": "Done and ready for the inspection",
    "office_action": "Our part is done; the request is with the office"
  },
  "timingDefault": "3-m (no time flag in the master file)"
}
